module.exports = __webpack_public_path__ + "img/pd_D1.10.608464cc.png";